import { Box, Stack, Typography, type CSSObject } from '@mui/material';
import {
  CompaniesCarousel,
  Contact,
  GalleryTeam,
  Layout,
  MacBookWindow,
  NumberStack,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { TeamData } from './Team.data';
import { teamSeo } from './Team.seo';
import { CompaniesStyledStack, StyledCompaniesHeader } from './Team.styles';
import type { TeamProps } from './Team.types';
import { WhatWeDo } from './WhatWeDo';
import { StaticImageData } from 'next/image';

export const Team = ({ blogPosts }: TeamProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...teamSeo} />
      <Section>
        <MacBookWindow
          title="Hi there!"
          description="We’re Rumble Fish a team of passionate professionals on a
                mission to help you build the most amazing digital products."
          buttonText="See our case studies"
          buttonLink="/case-studies"
          gradient="blue-purple"
        />
      </Section>

      <Section width="normal">
        <CompaniesStyledStack>
          <StyledCompaniesHeader variant="strong_400">
            We were established in 2017 and since then we’ve helped dozens of
            entrepreneurs reach their business goals<br></br> through
            state-of-the-art technology. Join them!
          </StyledCompaniesHeader>
          <CompaniesCarousel />
        </CompaniesStyledStack>
      </Section>

      <Section width="normal" pb={6}>
        <Stack
          sx={{
            width: '70%',
            height: 'calc(30vw / 2)',
            borderRadius: '0 0 calc(70vw / 2) calc(70vw / 2)',
            position: 'absolute',
            transform: 'translateX(-50%) translateY(0%) translateZ(0)',
            zIndex: -1,
            left: '50%',
            background: 'rgba(255,255,255,0.06)',
            willChange: 'transform',
            filter: 'blur(200px)',
          }}
        />

        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(10),

            [theme.breakpoints.down('md')]: {
              flexDirection: 'column',
              gap: theme.spacing(5),
            },
          })}>
          <Typography
            variant="strong_600"
            sx={(theme) => ({
              ...(theme.mixins.neutralGradient as CSSObject),
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            })}>
            We think outside the box to find the best possible ways to make your
            business idea a reality. Our unique skillset and focus on continuous
            knowledge gaining are what makes us different. Rumble Fish is your
            trusted end- to-end software development partner - we take care of
            technology so that you can focus on your business.
          </Typography>

          <Box
            sx={(theme) => ({
              flex: 1,

              minWidth: '50%',
              [theme.breakpoints.down('sm')]: {
                minWidth: '100%',
              },
            })}>
            <Box>
              <img
                style={{
                  width: '100%', // Set the width to a fixed value
                  height: '100%', // Set the height to the same fixed value
                  objectFit: 'cover', // Ensure the image covers the box without distortion
                }}
                alt=""
                src={
                  (TeamData.image1 as unknown as StaticImageData)?.src
                }></img>
            </Box>
          </Box>
        </Stack>
      </Section>

      <Section pt={6} width="normal">
        <Stack
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <NumberStack counters={TeamData.counters} />
        </Stack>
      </Section>

      <Section pt={6} width="normal" pb={6}>
        <WhatWeDo />
      </Section>

      <Section width="normal" pt={10} pb={10}>
        <GalleryTeam teamData={TeamData.gallery} />
      </Section>

      <Contact
        subtitle="We will answer any questions you may have related to About us!"
        color="orange"
      />
    </Layout>
  );
};
